const getConfig = (root, kind = 'config') => {
    const selector = `script[data-kind="${kind}"][type="application/json"]`;
    return [...root.querySelectorAll(selector)].map((script) => JSON.parse(script.textContent));
};

const paymentType = 'paypal:button';

Alpine.data('SevenPaymentPaypalButton', (element) => ({
    isSupported: false,
    instance: null,
    sdk: null,

    config: getConfig(element).at(-1),

    async init() {
        this.instance = await new Promise((resolve) => {
            document.addEventListener('seven:payment:paypal:client:init', (event) => resolve(event.detail));
        });

        const button = this.instance.paypal.Buttons({
            ...this.config,
            onClick: this._onClick.bind(this),
            onApprove: this._onApprove.bind(this),
            createOrder: this._createOrder.bind(this),
            onInit: this._dispatchEvent.bind(this, 'init'),
            onCancel: this._dispatchEvent.bind(this, 'cancel'),
            onError: this._dispatchEvent.bind(this, 'error'),
        });

        if (button?.isEligible()) {
            this.isSupported = true;
            button?.render(element);
        } else {
            element.closest('.payment-method-selection li').remove();
        }
    },

    _onClick(detail, actions) {
        return new Promise((resolve) => {
            this._dispatchEvent('click', {
                ...detail,
                actions: {
                    resolve: () => resolve(actions.resolve()),
                    reject: () => resolve(actions.reject()),
                },
            });
        });
    },

    async _createOrder() {
        const {token, redirectUrl} = await this.instance.createOrder(this.config.id);
        this.redirectUrl = redirectUrl;
        return token;
    },

    async _onApprove() {
        this._dispatchEvent('paymentcompleted');
        if (this.redirectUrl) {
            window.location.href = this.redirectUrl;
        }
    },

    _dispatchEvent(name, { cancelable, bubbles, ...detail } = {}) {
        return element.dispatchEvent(new CustomEvent(`seven:payment:paypal:button:${name}`, {
            detail,
            bubbles: bubbles ?? true,
            cancelable: cancelable ?? true,
        }));
    },
}));


